<div class="container-fluid mt-4">
    <div class="row">

        <div class="col-lg-12 d-flex justify-content-between align-items-center">

            <div class="col-md-2 mb-2">

            </div>
            <div class="col-10 mb-2 text-end">
                <button (click)="back()" class="btn btn-secondary" style="font-size: large;">
                    Back
                </button>
                &nbsp;
                <button class="btn btn-primary" (click)="downloadCertificate()">
                    <i class="fa fa-download me-1"></i> Print Application
                </button>


            </div>
        </div>
    </div>
    <div class="row"  #certificateContainer>
        <div class="col-lg-12 ">
            <div class="col-lg-12 audit-certificate-logo">
                    <div class="print-wrapper certificate-card">

                        <div class="col-lg-12 text-center mb-3">
                            <img src="../../assets/images/logos/hplogo.png" alt="HP Logo" class="gov-logo">
                            <div class="brand-title">
                                DEPARTMENT OF COOPERATION <br>
                                GOVERNMENT OF HIMACHAL PRADESH
                            </div>
                            <p class="text-center mt-1" style="font-size:15px;">
                                UNDER HP SOCIETIES REGISTRATION ACT, 1968
                            </p>



                        </div>


                        <h6 class="col-lg-12 text-end mb-3">Audit Year: {{ tempAuditYear }}</h6>

                    </div>
              
                <br />
                <div class="card certificate-card">

                    <div class="card-header">
                        <h5 class="election-title">🗂️ Society Information</h5>
                    </div>
                    <div class="card-body">

                        <div class="row">
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Society Name</strong></label>
                                <p class="m-0">{{ trans?.sSocietyName }}</p>

                            </div>
                            <!-- Address -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Address</strong></label>
                                <p class="m-0">{{ trans?.address }}</p>
                            </div>

                            <!-- Registration Date -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Registration Date</strong></label>
                                <p class="m-0">{{ formatDateToYYYYMMDD(trans?.dFinishApplicationdate) }}</p>
                            </div>

                            <!-- Registration No. -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Registration No.</strong></label>
                                <p class="m-0">{{ trans?.sSocietyRegistrationNo }}</p>
                            </div>

                            <!-- Society Category -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Society Category</strong></label>
                                <p class="m-0">{{ trans?.categoryName }}</p>
                            </div>

                            <!-- Society Type -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Society Type</strong></label>
                                <p class="m-0">{{ trans?.type }}</p>
                            </div>
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Society Kind</strong></label>
                                <p class="m-0">
                                    {{ trans?.iSKindid == 3 ? 'Credit' : trans?.iSKindid == 4 ? 'Non-Credit' :
                                    '-'
                                    }}
                                </p>
                            </div>

                        </div>
                    </div>
                    <div class="card-header" style="border-radius: 0 !important;">
                        <h5 class="election-title">Society Status</h5>
                    </div>
                    <div class="card-body">

                        <div class="row">

                            <!-- Audit Year -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Audit Society Status</strong></label>
                                <p class="m-0">{{ trans?.statusSocieties }}</p>
                            </div>


                        </div>
                    </div>
                    <div class="card-header" style="border-radius: 0 !important;">
                        <h5 class="election-title">Society Building Details</h5>
                    </div>
                    <div class="card-body">

                        <div class="row">


                            <!-- Society Building -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Society Building</strong></label>
                                <p class="m-0">
                                    {{ trans?.iSocietyBuilding === true ? 'Yes' : (trans?.iSocietyBuilding ===
                                    false
                                    ? 'No' : '') }}
                                </p>
                            </div>

                            <!-- Building Type -->
                            <div class="col-lg-4 col-md-6 mb-2" *ngIf=" trans?.iSocietyBuilding === true">
                                <label class="form-label m-0"><strong>Building Type</strong></label>
                                <p class="m-0">{{ trans.buildingType }}</p>
                            </div>

                            <!-- Building Remarks -->
                            <div class="col-lg-12 mb-2" *ngIf=" trans?.iSocietyBuilding === true">
                                <label class="form-label m-0"><strong>Remarks</strong></label>

                                <p class="m-0"> {{ trans.buildingRemarks }} </p>
                            </div>

                        </div>
                    </div>
                    <div class="card-header" style="border-radius: 0 !important;">
                        <h5 class="election-title">Society Land Details</h5>
                    </div>
                    <div class="card-body">

                        <div class="row">

                            <!-- Land Details -->
                            <div class="col-lg-3 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Land Details</strong></label>
                                <p class="m-0">
                                    {{ trans?.iLandDetailType === true ? 'Yes' : (trans?.iLandDetailType ===
                                    false
                                    ? 'No' : '') }}</p>
                            </div>

                            <!-- Type of Possession -->
                            <div class="col-lg-3 col-md-6 mb-2" *ngIf=" trans?.iLandDetailType === true">
                                <label class="form-label m-0"><strong>Type of Possession</strong></label>

                                <p class="m-0">{{ trans.possessionType }}</p>
                            </div>

                            <!-- Area -->
                            <div class="col-lg-3 col-md-6 mb-2" *ngIf=" trans?.iLandDetailType === true">
                                <label class="form-label m-0"><strong>Area</strong></label>

                                <p class="m-0">{{ trans.landArea }}</p>
                            </div>

                            <!-- Land Remarks -->
                            <div class="col-lg-12 mb-2" *ngIf=" trans?.iLandDetailType === true">
                                <label class="form-label m-0"><strong>Remarks</strong></label>
                                <p class="m-0">{{ trans.landRemark }}</p>

                            </div>
                        </div>


                    </div>
                </div>
            </div>

            <div class="col-lg-12 certificate-card">
                <div class="card">
                    <div class="card-header">
                        <h5 class="election-title">🧑‍🏫 Members and Employee Details</h5>
                    </div>
                    <div class="card-body">
                        <div class="row">

                            <!-- General Member Fields -->
                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="trans?.iSCategoryid != 1">
                                <label class="form-label m-0"><strong>Total Society Members </strong></label>
                                <p class="m-0">{{ auditMember?.totalMember }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="trans?.iSCategoryid != 1">
                                <label class="form-label m-0"><strong>Cooperative Societies No</strong>
                                </label>
                                <p class="m-0">{{ auditMember?.coOperativeSocietyNo }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Total Individuals Number</strong></label>
                                <p class="m-0">{{ auditMember?.totalIndividualNo }}</p>

                            </div>

                            <!-- Gender Fields -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Male Member No</strong> </label>
                                <p class="m-0">{{ auditMember?.maleMember }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Female Member No </strong></label>
                                <p class="m-0">{{ auditMember?.femaleMember }}</p>

                            </div>

                            <!-- Caste Category Fields -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>General Member No</strong></label>
                                <p class="m-0">{{ auditMember?.generalMemberNo }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>OBC Member No</strong></label>
                                <p class="m-0">{{ auditMember?.obcMemberNo }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>SC Member No</strong></label>
                                <p class="m-0">{{ auditMember?.scMemberNo }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>ST Member No</strong></label>
                                <p class="m-0">{{ auditMember?.stMemberNo }}</p>

                            </div>
                            <!-- <div class="col-lg-4 col-md-6 mb-2">
                            <label class="form-label m-0"><strong>Trained Member No</strong></label>
                            <p class="m-0">{{ auditMember?.generaltrainedEmployees }}</p>

                        </div>

                        <div class="col-lg-4 col-md-6 mb-2">
                            <label class="form-label m-0"><strong>Non-Trained Member No</strong></label>
                            <p class="m-0">{{ auditMember?.generalnonTrainedEmployees }}</p>

                        </div> -->

                        </div>
                    </div>
                    <div class="card-header" style="border-radius: 0 !important;">
                        <h5 class="election-title">Management Committee Details</h5>
                    </div>
                    <div class="card-body">
                        <div class="row">


                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Total Committee Members No</strong> </label>
                                <p class="m-0">{{ auditMember?.totalNoCommittee }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Total Person on Positions No</strong></label>
                                <p class="m-0">{{ auditMember?.totalPersonOnPositons }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Vacant Positions </strong></label>
                                <p class="m-0">{{ auditMember?.vacantPositions }}</p>

                            </div>
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Trained Member No</strong></label>
                                <p class="m-0">{{ auditMember?.trainedmember }}</p>

                            </div>
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Non-Trained Member No</strong></label>
                                <p class="m-0">{{ auditMember?.nonTrainedmember }}</p>


                            </div>

                        </div>
                    </div>
                    <div class="card-header" style="border-radius: 0 !important;">
                        <h5 class="election-title">Employee Details</h5>
                    </div>
                    <div class="card-body">
                        <div class="row">

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Total Employees No</strong> </label>
                                <p class="m-0">{{ auditMember?.totalNumberOfEmployess }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Trained Employees No </strong></label>
                                <p class="m-0">{{ auditMember?.trainedEmployees }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Non-Trained Employees No </strong></label>
                                <p class="m-0">{{ auditMember?.nonTrainedEmployees }}</p>

                            </div>
                            <hr>
                            <!-- <div class="col-lg-4 col-md-6 mb-2">
                            <label class="form-label m-0"><strong>Secretary Type </strong></label>
                            <p class="m-0">{{ auditMember?.sectarytype }}</p>

                        </div> -->


                        </div>

                    </div>
                </div>
            </div>

            <div class="col-lg-12 certificate-card">
                <div class="card">
                    <div class="card-header" style="border-radius: 0 !important;">
                        <h5 class="election-title">🧰 Society Services</h5>
                    </div>
                    <div class="card-body">

                        <div class="row">

                            <!-- GST NO -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>GST No</strong></label>
                                {{ service?.gstNo || '-'}}


                            </div>

                            <!-- PAN NO -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>PAN No</strong></label>
                                {{ service?.panNo || '-'}}


                            </div>

                            <!-- TAN NO -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>TAN No</strong></label>
                                {{ service?.tanNo || '-'}}


                            </div>

                            <!-- EPF NO -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>EPF No</strong></label>
                                {{ service?.epfNo || '-' }}


                            </div>
                        </div>
                    </div>
                    <br />
                    <div class="col-lg-12">
                        <ng-container *ngFor="let ser of lstBussinessUpgrades">
                            <ng-container *ngIf="ser.checkd">
                                <div class="card">
                                    <div class="card-header" style="border-radius: 0 !important;">
                                        <h5 class="election-title">{{ ser.name }}</h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <ng-container
                                                *ngIf="ser.groupedSubFields && ser.groupedSubFields.length > 0">
                                                <ng-container *ngFor="let group of ser.groupedSubFields">
                                                    <div class="col-12 my-2" *ngIf="group.heading">
                                                        <h6 class="text-secondary fw-bold">{{ group.heading }}</h6>
                                                    </div>

                                                    <ng-container
                                                        *ngIf="group.fields && group.fields.length > 0; else handleGroupWithoutFields">
                                                        <div class="row">
                                                            <div class="col-md-6 mb-3"
                                                                *ngFor="let subSer of group.fields">
                                                                <label class="form-label">
                                                                    {{ subSer.labelName }}
                                                                    <span class="text-danger"
                                                                        *ngIf="subSer.isRequired">*</span>
                                                                </label>

                                                                <p class="form-control-static">
                                                                    <ng-container
                                                                        [ngSwitch]="subSer.inputType?.toLowerCase()">
                                                                        <ng-container *ngSwitchCase="'dropdown'">
                                                                            {{ subSer.value?.length ?
                                                                            subSer.value.join(',
                                                                            ') : '-' }}
                                                                        </ng-container>
                                                                        <ng-container *ngSwitchCase="'boolean'">
                                                                            {{ subSer.value === true ? 'Yes' :
                                                                            (subSer.value
                                                                            === false ? 'No' : '-') }}
                                                                        </ng-container>
                                                                        <ng-container *ngSwitchDefault>
                                                                            {{ subSer.value != null && subSer.value !==
                                                                            '' ?
                                                                            subSer.value : '-' }}
                                                                        </ng-container>
                                                                    </ng-container>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </ng-container>

                                                    <ng-template #handleGroupWithoutFields>
                                                        <div class="col-md-6 mb-3">
                                                            <label class="form-label">
                                                                {{ group.labelName }}
                                                                <span class="text-danger"
                                                                    *ngIf="group.isRequired">*</span>
                                                            </label>

                                                            <p class="form-control-static">
                                                                <ng-container
                                                                    [ngSwitch]="group.inputType?.toLowerCase()">
                                                                    <ng-container *ngSwitchCase="'dropdown'">
                                                                        {{ group.value?.length ? group.value.join(', ')
                                                                        :
                                                                        '-' }}
                                                                    </ng-container>
                                                                    <ng-container *ngSwitchCase="'boolean'">
                                                                        {{ group.value === true ? 'Yes' : (group.value
                                                                        ===
                                                                        false ? 'No' : '-') }}
                                                                    </ng-container>
                                                                    <ng-container *ngSwitchDefault>
                                                                        {{ group.value != null && group.value !== '' ?
                                                                        group.value : '-' }}
                                                                    </ng-container>
                                                                </ng-container>
                                                            </p>
                                                        </div>

                                                        <!-- Conditional Fields for Boolean TRUE -->
                                                        <div *ngIf="group.inputType?.toLowerCase() === 'boolean' && group.value === true && group.groupedConditionalFields?.length"
                                                            class="row mt-3">
                                                            <div class="col-12"
                                                                *ngFor="let groupItem of group.groupedConditionalFields">
                                                                <div *ngIf="groupItem.heading && groupItem.heading !== 'General'"
                                                                    class="mb-2">
                                                                    <h6 class="fw-bold text-decoration-underline">{{
                                                                        groupItem.heading }}</h6>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-6 mb-3"
                                                                        *ngFor="let cond of groupItem.fields">
                                                                        <label class="form-label">
                                                                            {{ cond.labelName }}
                                                                            <span class="text-danger"
                                                                                *ngIf="cond.isRequired">*</span>
                                                                        </label>
                                                                        <p class="form-control-static">
                                                                            <ng-container
                                                                                [ngSwitch]="cond.inputType?.toLowerCase()">
                                                                                <ng-container
                                                                                    *ngSwitchCase="'dropdown'">
                                                                                    {{ cond.value?.length ?
                                                                                    cond.value.join(', ') : '-' }}
                                                                                </ng-container>
                                                                                <ng-container *ngSwitchCase="'boolean'">
                                                                                    {{ cond.value === true ? 'Yes' :
                                                                                    (cond.value === false ? 'No' : '-')
                                                                                    }}
                                                                                </ng-container>
                                                                                <ng-container *ngSwitchDefault>
                                                                                    {{ cond.value != null && cond.value
                                                                                    !==
                                                                                    '' ? cond.value : '-' }}
                                                                                </ng-container>
                                                                            </ng-container>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-template>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>

                </div>


            </div>



            <div class="col-lg-12 certificate-card">
                <div class="card">
                    <div class="card-header">
                        <h5 class="election-title">📊 Audit Details</h5>
                    </div>
                    <div class="card-body">
                        <div class="row">


                            <!-- Audit Year -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Audit Year</strong> </label>
                                <p class="m-0">{{ trans?.sAuditYear }}</p>

                            </div>

                            <!-- Auditor Name -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0">
                                    <strong> Auditor Name</strong>
                                </label>

                                <p class="m-0">{{ allotData?.fullName }}</p>
                            </div>

                            <!-- Audit Allotment Date -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0">
                                    <strong>Audit Allotment Date </strong>
                                </label>
                                <p class="m-0">{{ allotData?.auditAllotDate }}</p>
                            </div>


                            <!-- Working Capital -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"> <strong>Working Capital</strong></label>
                                <p class="m-0">{{ trans?.workingCapital }}</p>

                            </div>

                            <!-- Audit Classification (in Lakhs) -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"> <strong>Audit Classification<sup> (in
                                            Lakhs)</sup></strong>
                                </label>
                                <p class="m-0">{{ trans?.auditClassification }}</p>

                            </div>

                            <!-- Audit Start Date -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"> <strong>Audit Start Date</strong></label>
                                <p class="m-0">{{formatDateToYYYYMMDD(trans?.auditStartDate) }}</p>

                            </div>

                            <!-- Submission Date -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"> <strong>Submission Date</strong> </label>
                                <p class="m-0">{{ formatDateToYYYYMMDD(trans?.submissionDate) }}</p>

                            </div>

                            <!-- General House Meeting Date -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"> <strong>Last General House Meeting Date</strong> </label>
                                <p class="m-0">{{ formatDateToYYYYMMDD(trans?.ghmDate)}}</p>

                            </div>



                        </div>

                    </div>
                </div>
            </div>

            <div class="col-lg-12 certificate-card">
                <div class="card">
                    <div class="card-header">
                        <h5 class="election-title">📈 Balance Sheet</h5>
                    </div>
                    <div class="card-body">

                        <div class="row">


                        </div>
                        <div class="col-lg-4 col-md-6 mb-2">
                            <label class="form-label m-0"> <strong>As On Date</strong></label>
                            <p class="m-0">{{ asOnDate | date: 'dd-MM-yyyy'}}</p>

                        </div>

                        <div class="row mt-2" *ngIf="UploadbalanceList || sUploadRD || sUploadpnL">

                            <div class="d-flex flex-wrap gap-6 align-items-end">

                                <a *ngIf="UploadbalanceList" class="btn btn-success btn-sm" style="cursor:pointer"
                                    (click)="downloadFile(UploadbalanceList)">
                                    <i class="fa fa-download me-1"></i> BalanceSheet Download
                                </a>

                                <a *ngIf="sUploadRD" class="btn btn-success btn-sm" style="cursor:pointer"
                                    (click)="downloadFile(sUploadRD)">
                                    <i class="fa fa-download me-1"></i>
                                    Download RD
                                </a>

                                <a *ngIf="sUploadpnL" class="btn btn-success btn-sm" style="cursor:pointer"
                                    (click)="downloadFile(sUploadpnL)">
                                    <i class="fa fa-download me-1"></i>
                                    Download PnL
                                </a>


                            </div>
                        </div>
                        <div class="row">

                            <!-- Liabilities Table -->
                            <div class="col-lg-12 mt-3">
                                <h5>Liabilities</h5>
                                <ngx-datatable
                                    class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                    [rows]="liabilityData" [columns]="column" [columnMode]="'force'" [headerHeight]="50"
                                    [footerHeight]="0" rowHeight="auto"
                                    [style.height.px]="getTableHeight(liabilityData.length)"
                                    [count]="liabilityData.length" [scrollbarV]="false" [scrollbarH]="false"
                                    [loadingIndicator]="loading">
                                    <ngx-datatable-column name="#" [sortable]="false" [width]="50">
                                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex">
                                            <span>{{ rowIndex + 1 }}</span>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <ngx-datatable-column *ngFor="let col of column" [name]="col.name" [prop]="col.prop"
                                        [sortable]="true">
                                        <ng-template let-value="value" ngx-datatable-cell-template>
                                            {{ value }}
                                        </ng-template>
                                    </ngx-datatable-column>
                                </ngx-datatable>
                                <!-- Liabilities Total -->
                                <div class="text-end mt-2">
                                    <h5><strong>Total (Liabilities): ₹ {{ totalLiability | number: '1.2-2'
                                            }}</strong></h5>
                                </div>
                            </div>

                            <!-- Assets Table -->
                            <div class="col-lg-12 mt-3">
                                <h5>Assets</h5>
                                <ngx-datatable
                                    class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                    [rows]="assetData" [columns]="column" [columnMode]="'force'" [headerHeight]="50"
                                    [footerHeight]="0" rowHeight="auto"
                                    [style.height.px]="getTableHeight(assetData.length)" [count]="assetData.length"
                                    [scrollbarV]="false" [scrollbarH]="false" [loadingIndicator]="loading">
                                    <ngx-datatable-column name="#" [sortable]="false" [width]="50">
                                        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex">
                                            <span>{{ rowIndex + 1 }}</span>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <ngx-datatable-column *ngFor="let col of column" [name]="col.name" [prop]="col.prop"
                                        [sortable]="true">
                                        <ng-template let-value="value" ngx-datatable-cell-template>
                                            {{ value }}
                                        </ng-template>
                                    </ngx-datatable-column>
                                </ngx-datatable>
                                <!-- Assets Total -->
                                <div class="text-end mt-2">
                                    <h5><strong>Total (Assets): ₹ {{ totalAsset | number: '1.2-2' }}</strong></h5>
                                </div>
                            </div>
                            <div class="col-lg-12 mt-3 text-end border-top pt-2">
                                <h5><strong>Total (Liabilities + Assets): ₹ {{ totalLiability + totalAsset | number:
                                        '1.2-2' }}</strong>
                                </h5>
                            </div>





                        </div>

                    </div>
                </div>
            </div>

            <div class="col-lg-12 certificate-card">
                <div class="card">
                    <div class="card-header">
                        <h5 class="election-title">📋 Other Details</h5>
                    </div>
                    <div class="card-body">
                        <div class="row">

                            <!-- Income -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Turnover</strong></label>
                                <p class="m-0">{{ otherParams?.income }}</p>

                            </div>

                            <!-- Expenditure -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Total Expense</strong></label>
                                <p class="m-0">{{ otherParams?.expenditure }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="otherParams?.profit">
                                <label class="form-label m-0"><strong>Total Net Profit</strong></label>
                                <p class="m-0">{{ otherParams?.profit }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="otherParams?.loss">
                                <label class="form-label m--0"><strong>Total Net Loss</strong></label>
                                <p class="m-0">{{ otherParams?.loss }}</p>

                            </div>
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Audit Fees</strong></label>
                                <p class="m-0">{{ otherParams?.auditFees }}</p>

                            </div>
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Do you Have Branches</strong>
                                </label>

                                <p class="m-0">
                                    {{ otherParams?.branches === true ? 'Yes' :
                                    (otherParams?.branches === false ? 'No' : '') }}
                                </p>


                            </div>


                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="otherParams?.branches === true">
                                <label class="form-label m-0"><strong>No. of Branches</strong></label>
                                <p class="m-0">{{ otherParams?.noOfBranches }}</p>

                            </div>


                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="otherParams?.branches === true">
                                <label class="form-label m-0"><strong>Branches Fees</strong></label>
                                <p class="m-0">{{ otherParams?.bauditFees }}</p>

                            </div>
                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="otherParams?.branches === true">
                                <label class="form-label m-0"><strong>Total Audit Fee </strong></label>
                                <p class="m-0">{{ otherParams?.auditTFees }}</p>

                            </div>
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Govt. Guarantee</strong>
                                </label>

                                <p class="m-0">
                                    {{ otherParams?.guarantee === true ? 'Yes' :
                                    (otherParams?.guarantee === false ? 'No' : '') }}
                                </p>


                            </div>
                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="otherParams?.guarantee === true">
                                <label class="form-label m-0"><strong>Total Amount </strong></label>
                                <p class="m-0">{{ otherParams?.totalamount }}</p>

                            </div>



                            <!-- Govt Share -->
                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                <label class="form-label m-0"><strong>Govt. Share</strong></label>
                                <p class="m-0">{{ otherParams?.govtShare }}</p>

                            </div>
                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                <label class="form-label m-0"><strong>Govt. Share Principal </strong> </label>
                                <p class="m-0">{{ otherParams?.govtLoanPrincipal }}</p>

                            </div>

                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                <label class="form-label m-0"><strong>Govt. Share Interest</strong> </label>
                                <p class="m-0">{{ otherParams?.govtLoanInterest }}</p>

                            </div>


                            <!-- Redemption of Govt. Share -->
                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                <label class="form-label m-0"><strong>Redemption of Govt. Share</strong></label>
                                <p class="m-0">{{ otherParams?.redemptionOfGovtShare }}</p>

                            </div>

                            <!-- Govt. Dividend Payable -->
                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                <label class="form-label m-0"><strong>Govt. Dividend Payable</strong> </label>
                                <p class="m-0">{{ otherParams?.govtDividentPayable }}</p>

                            </div>


                            <!-- Govt. Dividend Paid -->
                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                <label class="form-label m-0"><strong>Govt. Dividend Paid</strong></label>
                                <p class="m-0">{{ otherParams?.govtDividentPaid }}</p>

                            </div>

                            <!-- Govt. Loan -->
                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                <label class="form-label m-0"><strong>Govt. Loan</strong></label>
                                <p class="m-0">{{ otherParams?.govtLoan }}</p>

                            </div>

                            <!-- Recovery of Principal -->
                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                <label class="form-label m-0"><strong>Recovery of Principal</strong></label>
                                <p class="m-0">{{ otherParams?.recoveryOfPrincipal }}</p>

                            </div>

                            <!-- Recovery of Interest -->
                            <div class="col-lg-4 col-md-6 mb-2" *ngIf="GovtData">
                                <label class="form-label m-0"><strong>Recovery of Interest</strong> </label>
                                <p class="m-0">{{ otherParams?.recoveryOfInterest }}</p>

                            </div>

                            <!-- Misappropriation -->
                            <div class="col-lg-4 col-md-6 mb-2">
                                <label class="form-label m-0"><strong>Misappropriation/Embezzlement</strong>
                                </label>

                                <p class="m-0">
                                    {{ otherParams?.misappropriationEmbezzlement === true ? 'Yes' :
                                    (otherParams?.misappropriationEmbezzlement === false ? 'No' : '') }}
                                </p>


                            </div>

                            <!-- Date of Detection -->
                            <div class="col-lg-4 col-md-6 mb-2"
                                *ngIf="otherParams?.misappropriationEmbezzlement === true">
                                <label class="form-label m-0"><strong>Date of Detection</strong> </label>
                                <p class="m-0">{{ otherParams?.dateOfDetection | date: 'dd/MM/yyyy' }}</p>



                            </div>

                            <!-- Amount Involved -->
                            <div class="col-lg-4 col-md-6 mb-2"
                                *ngIf="otherParams?.misappropriationEmbezzlement === true">
                                <label class="form-label m-0"><strong>Amount Involved</strong></label>
                                <p class="m-0">{{ otherParams?.amountInvolved }}</p>

                            </div>
                            <div class="col-lg-4 col-md-6 mb-2"
                                *ngIf="otherParams?.misappropriationEmbezzlement === true">
                                <label class="form-label m-0"><strong>Total Amount Recovered</strong></label>
                                <p class="m-0">{{ otherParams?.amountRecoverd }}</p>

                            </div>

                            <!-- Special Report -->
                            <div class="col-lg-4 col-md-6 mb-2"
                                *ngIf="otherParams?.misappropriationEmbezzlement === true">
                                <label for="specialReport" class="form-label m-0"><strong>Special Report</strong>
                                </label>

                                <p class="m-0">
                                    {{ otherParams?.specialReport === true ? 'Yes' : (otherParams?.specialReport
                                    ===
                                    false ? 'No' : '') }}
                                </p>

                            </div>
                            <div class="col-lg-4 col-md-6 mb-2"
                                *ngIf="otherParams?.misappropriationEmbezzlement === true">
                                <label class="form-label m-0"><strong>Remark</strong></label>
                                <p class="m-0">{{ otherParams?.remark }}</p>

                            </div>


                        </div>


                    </div>
                </div>
            </div>
        </div>